import { Box, Stack } from '@mui/material';
import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import {
  MultipleSearchQueryProvider,
  SearchParamsProvider,
} from 'components/search/search.context';
import {
  useSearchParams,
  useSearchQuery,
} from 'components/search/search.hooks';
import JobsStatusGate from 'components/jobs-status-gate/jobs-status-gate.component';
import { useMessagesSearchParams } from '../email-pulse.hooks';
import EmailPulseHeader from '../email-pulse-header/email-pulse-header.component';
import MessagesSummaryCards from './messages-summary-cards.component';
import ApiDetailsDrawer from '../email-pulse-api-definitions/api-details-drawer.component';
import { transformEmailPulseDataGridResponse } from '../email-pulse.utils';
import {
  useGetEmailPulseMarketingSummaryQuery,
  useGetEmailPulseMarketingEmailsOpenedBreakdownQuery,
  useGetEmailPulseMarketingEmailsBouncedBreakdownQuery,
  useGetEmailPulseMarketingDataQuery,
  useExportEmailPulseMarketingMutation,
} from 'api/reports-service/email-pulse-hooks';
import MessagesDataGrid from './messages-data-grid/messages-data-grid.component';

const filteredSearchParams = ['offerIds', 'emailType'];

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(useMessagesSearchParams());
  return (
    <SearchParamsProvider value={searchParams}>
      <Messages />
    </SearchParamsProvider>
  );
};

const Messages = () => {
  const { open, close, isOpen } = useDrawer();

  const messagesSummary = useSearchQuery(
    useGetEmailPulseMarketingSummaryQuery,
    {
      filteredSearchParams,
    },
  );

  const emailsOpenedBreakdown = useSearchQuery(
    useGetEmailPulseMarketingEmailsOpenedBreakdownQuery,
    {
      filteredSearchParams,
    },
  );

  const emailsBouncedBreakdown = useSearchQuery(
    useGetEmailPulseMarketingEmailsBouncedBreakdownQuery,
    {
      filteredSearchParams,
    },
  );

  const messagesDataGrid = useSearchQuery(useGetEmailPulseMarketingDataQuery, {
    filteredSearchParams,
    getSearchResults: response =>
      transformEmailPulseDataGridResponse(response, 'id', 'messageTitle'),
  });

  return (
    <Stack marginTop={2}>
      <MultipleSearchQueryProvider
        value={{
          queries: {
            marketingSummary: messagesSummary,
            emailsOpenedBreakdown,
            emailsBouncedBreakdown,
            marketingDataGrid: messagesDataGrid,
          },
        }}
      >
        <Stack spacing={2}>
          <SearchToolbar />
          <EmailPulseHeader open={open} />

          {/* Summary Cards */}
          <MessagesSummaryCards />

          {/* Data Grid */}
          <Box height={{ xs: 400, sm: 600 }}>
            <MessagesDataGrid
              data-testid="Messages.MessagesDataGrid"
              queryName="marketingDataGrid"
              useExportMutation={useExportEmailPulseMarketingMutation}
            />
          </Box>
        </Stack>
      </MultipleSearchQueryProvider>
      <ApiDetailsDrawer isOpen={isOpen} close={close} />
    </Stack>
  );
};

export default function GatedPage() {
  return (
    <JobsStatusGate>
      <SearchParamsWrapper />
    </JobsStatusGate>
  );
}
